import React from 'react'

import { useMediaQueryContext } from '@fourthwall/components'
import { routing } from '@utils/routing'

import type { Incentive as IncentiveType } from '../../../../Recommendations.types'
import { getBonus } from '../../utils'
import { Incentive } from '../Incentive'

type Props = {
  incentive: Extract<IncentiveType, { type: 'CREATE_PROMOTION' }>
}

export const PromotionIncentive = ({ incentive }: Props) => {
  const { tablet } = useMediaQueryContext()

  const getIncentivePromotionName = (incentive: Props['incentive']) => {
    switch (incentive.promotionType) {
      case 'FreeShipping':
        return {
          icon: '🚚',
          label: 'Offer free shipping',
        }
      default:
        return {
          icon: '🚚',
          label: 'Offer promotion',
        }
    }
  }

  return (
    <Incentive
      type={incentive.type}
      icon={getIncentivePromotionName(incentive).icon}
      label={getIncentivePromotionName(incentive).label}
      isCompleted={incentive.isCompleted}
      bonus={getBonus(incentive.bonus)}
      button={{
        label: tablet ? 'Set up free shipping' : 'Set up',
        to: `${routing.promotions.promotionCodes.create.self}?mode=free-shipping`,
      }}
    />
  )
}
